const bucket = process.env.REACT_APP_BUCKET
const bucketLegacy = process.env.REACT_APP_BUCKET_LEGACY

export { bucket, bucketLegacy }
